/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalServiceGroupCreateReqVo
 */
export interface AdditionalServiceGroupCreateReqVo {
    /**
     * 附加服务组名称，必传
     * @type {string}
     * @memberof AdditionalServiceGroupCreateReqVo
     */
    name: string;
    /**
     * 附加服务组名称（中文），必传
     * @type {string}
     * @memberof AdditionalServiceGroupCreateReqVo
     */
    nameCn: string;
    /**
     * 附加服务组编码，必传
     * @type {string}
     * @memberof AdditionalServiceGroupCreateReqVo
     */
    code: string;
    /**
     * 排序，必须大于等于 0，必传
     * @type {number}
     * @memberof AdditionalServiceGroupCreateReqVo
     */
    sort: number;
    /**
     * 仓库 ID，关联仓库表，必传
     * @type {number}
     * @memberof AdditionalServiceGroupCreateReqVo
     */
    warehouseId: number;
    /**
     * 是否可用：0-不可用，1-可用，默认可用，必传
     * @type {number}
     * @memberof AdditionalServiceGroupCreateReqVo
     */
    enable: number;
}

/**
 * Check if a given object implements the AdditionalServiceGroupCreateReqVo interface.
 */
export function instanceOfAdditionalServiceGroupCreateReqVo(value: object): value is AdditionalServiceGroupCreateReqVo {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('nameCn' in value) || value['nameCn'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('sort' in value) || value['sort'] === undefined) return false;
    if (!('warehouseId' in value) || value['warehouseId'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    return true;
}

export function AdditionalServiceGroupCreateReqVoFromJSON(json: any): AdditionalServiceGroupCreateReqVo {
    return AdditionalServiceGroupCreateReqVoFromJSONTyped(json, false);
}

export function AdditionalServiceGroupCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalServiceGroupCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'nameCn': json['nameCn'],
        'code': json['code'],
        'sort': json['sort'],
        'warehouseId': json['warehouseId'],
        'enable': json['enable'],
    };
}

export function AdditionalServiceGroupCreateReqVoToJSON(json: any): AdditionalServiceGroupCreateReqVo {
    return AdditionalServiceGroupCreateReqVoToJSONTyped(json, false);
}

export function AdditionalServiceGroupCreateReqVoToJSONTyped(value?: AdditionalServiceGroupCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'nameCn': value['nameCn'],
        'code': value['code'],
        'sort': value['sort'],
        'warehouseId': value['warehouseId'],
        'enable': value['enable'],
    };
}

